import React, { useEffect, useState } from 'react';
import { MsalProvider } from '@azure/msal-react';
import { ensureMsalInitialized, msalInstance } from '../msalInstance';

interface AuthProviderProps {
  children: React.ReactNode;
}

const AuthProvider: React.FC<AuthProviderProps> = ({ children }) => {
  const [ready, setReady] = useState(false);

  useEffect(() => {
    ensureMsalInitialized()
      .then(() => setReady(true))
      .catch((error) => console.error('MSAL initialization failed:', error));
  }, []);

  if (!ready) {
    return null;
  }

  return (
    <MsalProvider instance={msalInstance}>
      {children}
    </MsalProvider>
  );
};

export default AuthProvider;
